// extracted by mini-css-extract-plugin
export default {"active":"NavigationFooter_active__6Ix8C"};